interface Month {
    en: string,
    th: string
}

export const MappingMonth: Array<Month> = [
    { en: 'January', th: 'มกราคม' },
    { en: 'February', th: 'กุมภาพันธ์' },
    { en: 'March', th: 'มีนาคม' },
    { en: 'April', th: 'เมษายน' },
    { en: 'May', th: 'พฤษภาคม' },
    { en: 'June', th: 'มิถุนายน' },
    { en: 'July', th: 'กรกฎาคม' },
    { en: 'August', th: 'สิงหาคม' },
    { en: 'September', th: 'กันยายน' },
    { en: 'October', th: 'ตุลาคม' },
    { en: 'November', th: 'พฤศจิกายน' },
    { en: 'December', th: 'ธันวาคม' }
]
